var t = /* @__PURE__ */ ((o) => (o.Image = "image", o.ImageOther = "image_other", o.Video = "video", o.Audio = "audio", o.Font = "font", o.Document = "document", o))(t || {});
export {
  t as FileTypeEnum
};
